import { Alert, Stack, Typography } from '@mui/material';

import type { TransferProblem } from '../../api/business/types';
import { problemParameters } from '../../components/transfers';
import { useT } from '../../i18n/LanguageContext';

/** A transfer's problems in the user's language — errors first — each with where it is and the detail for support. */
export const TransferProblems = ({ problems }: { problems: Array<TransferProblem> }) => {
  const t = useT();

  if (problems.length === 0) {
    return null;
  }

  const ordered = [...problems].sort((a, b) =>
    a.severity === b.severity ? 0 : a.severity === 'ERROR' ? -1 : 1,
  );

  return (
    <Stack spacing={1}>
      {ordered.slice(0, 50).map((problem, index) => (
        <Alert key={`${problem.code}-${index}`} severity={problem.severity === 'ERROR' ? 'error' : 'warning'}>
          {t(`transferProblem.${problem.code}` as const, problemParameters(problem))}
          {problem.path !== null || problem.detail !== null ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block', wordBreak: 'break-all' }}
            >
              {[problem.path, problem.detail].filter((part) => part !== null).join(' — ')}
            </Typography>
          ) : null}
        </Alert>
      ))}
      {ordered.length > 50 ? (
        <Typography variant="caption" color="text.secondary">
          {t('transfers.moreProblems', { count: ordered.length - 50 })}
        </Typography>
      ) : null}
    </Stack>
  );
};
